import React from 'react';
import { Link, useLoaderData } from '@remix-run/react';
import type { loader as homeLoader } from '~/routes/_app._index';
import { ReactComponent as ArrowRight } from '@rocco/icons/svg/arrow/arrow-right.svg';
import {
    formatNumberWithCommas,
    roundToNearest,
} from '@rocco/utils/format-number';
import { Button as RoccoButton } from '@rocco/components/button';
import { HomePageFeaturedCategories } from '@ui-rocco/pages/home-page/HomePageFeaturedCategories';
import { useCTAHandlers } from '~/ui-rocco/hooks/use-home-cta-actions';

export const HomePageProfessionals = () => {
    const { professionalSection, appDisplayMode } =
        useLoaderData<typeof homeLoader>();
    const { handleCTAClick } = useCTAHandlers('HomePageProfessionals');

    return (
        <section className="py-20 md:py-[10.25rem] md:pb-[7.2rem]">
            <div className="flex flex-col items-center justify-center gap-6 md:gap-12 pb-8 md:pb-24 px-4 md:px-0">
                <h3 className="text-center md:flex text-3xl gap-10.5 md:text-20 leading-[127.78%] md:leading-[100%] tracking-[-0.125rem]">
                    <span>{`${professionalSection.prefixTitle} `}</span>
                    <span className="inline-block rounded-full border-2 border-black px-4 md:px-7.5 py-0.5 leading-[100%] mx-2 md:mx-0">{`${formatNumberWithCommas(roundToNearest(professionalSection.count))}+`}</span>
                    <span>{`${professionalSection.suffixTitle}`}</span>
                </h3>
                <p className="px-6 md:px-0 py-2.5 text-center text-gray-700 md:max-w-[46.875rem] text-base md:text-5 md:leading-[130%] md:tracking-[0.025rem]">
                    {professionalSection.description}
                </p>
            </div>
            <HomePageFeaturedCategories
                categories={professionalSection.categories}
                title={professionalSection.categorySliderTitle ?? ''}
                appDisplayMode={appDisplayMode}
                section="HomePageProfessionals"
            />
            <div className="mt-12 text-center md:mt-[6.7rem]">
                <RoccoButton color="primary" asChild>
                    <Link
                        to={
                            professionalSection.CTAButton?.link ??
                            '/professionals'
                        }
                        onClick={() => handleCTAClick()}
                    >
                        {professionalSection.CTAButton?.text}
                        <ArrowRight className="ml-1.5 w-4" />
                    </Link>
                </RoccoButton>
            </div>
        </section>
    );
};
